export default {
  NEXT: "J'accepte",
  ACCEPT_PRIVACY_POLICY: 'Accpeter la politique de confidentialité',
  VERIFY_LOGIN: {
    TITLE: `Créez votre mot de passe`,
    SUMMARY: ``
  },
  VALIDATE: {
    TITLE: `Validez vos informations personnelles`,
    SUMMARY: ``
  },
  DO_NOT_FORGET: {
    TITLE: `Informations importantes`,
    SUMMARY: ``,
    THANK_YOU: `Merci,`,
    IMPORTANT_INFOS: `Voici les informations importantes que vous devez sauvegarder :`,
    USERNAMESECTION: `Votre nom d’utilisateur :`,
    EMPLOYEENUMBERSECTION: `Votre numéro d'employé:`,
    USERNAMEEMPLOYEENUMBERSECTION: "Votre nom d'utilisateur / numéro d'employé",
    PHONESECTION: `Numéro de téléphone Merinio :`,
    COMPANYSECTION: `Application web :`,
    HELPCENTRESECTION: `Centre d'aide :`,
    WELCOME: `Bienvenue dans votre compte Merinio! 🎉`,
    FINISH: `Entrez`,
    ACKNOWLEDGE: `Compris!`,
    ACKNOWLEDGED: `OK`
  },
  VERIFY_CONTACT_INFO: {
    TITLE: `Vérifiez vos informations de contact`,
    SUMMARY: ``,
    DONE: `Mes informations de contact sont à jour`
  },
  INVALID_TOKEN: `Lien invalide, expiré, ou déjà utilisé`,
  SAVE_PASSWORD_ERROR: `Il y a eu un problème en enregistrant votre mot de passe.`,
  ERROR: `Erreur`,
  SET_PASSWORD: `Choisissez votre mot de passe`,
  PASSWORD: {
    PLACEHOLDER: `Entrez le mot de passe`,
    LABEL: `Mot de passe`,
    DESCRIPTION: `Votre mot de passe doit contenir au entre 8 et 64 caractères`
  },
  CONFIRMPASSWORD: {
    PLACEHOLDER: `Entrez à nouveau le mot de passe`,
    LABEL: `Confirmer votre mot de passe`,
    DESCRIPTION: ``
  },
  PASSWORD_SAVE_ERROR: `Une erreur s'est produite lors de l'enregistrement de votre mot de passe. Veuillez contacter votre responsable.`,
  PASSWORDS_MUST_MATCH: `Les mots de passe doivent être les mêmes.`,
  ADDRESS: {
    PLACEHOLDER: `Entrez votre addresse courriel`,
    LABEL: `Adresse courriel`,
    DESCRIPTION: `Cette information est utilisée afin de vous envoyer les annonces, les notifications de quart de travail, les offres de quart de travail, etc.`
  },
  TYPE: {
    PLACEHOLDER: ``,
    LABEL: `Type`,
    DESCRIPTION: ``
  },
  MISSING_EMAIL: `Veuillez d'abord fournir une adresse courriel`,
  GO_TO_LOGIN: `Aller à la page de connexion`
}
